import React from 'react';
import Form from 'react-bootstrap/Form';
import './RuleEditor.css';

const Protocols = {
  IP: { hasPorts: false },
  TCP: { hasPorts: true },
  UDP: { hasPorts: true },
  ICMP: { hasPorts: false },
};

class Rule {
  constructor(action, chain, protocol, srcIp, srcPort, dstIp, dstPort, matchString) {
    this.action = action;
    this.chain = chain;
    this.protocol = protocol;
    this.srcIp = srcIp;
    this.srcPort = srcPort;
    this.dstIp = dstIp;
    this.dstPort = dstPort;
    this.matchString = matchString;
  }
  toString() {
    let command = 'iptables';
    command += ` --append ${this.chain}`;
    command += ` --protocol ${this.protocol}`;
    if (this.srcIp) command += ` --src ${this.srcIp}`;
    if (this.srcPort) command += ` --sport ${this.srcPort}`;
    if (this.dstIp) command += ` --dst ${this.dstIp}`;
    if (this.dstPort) command += ` --dport ${this.dstPort}`;
    if (this.matchString) command += ` --match string --algo bm --string '${this.matchString.replace(/\\/g, '\\\\').replace(/'/g, '\\\'')}'`;
    command += ` --jump ${this.action}`;

    return command;
  }
}

class RuleEditor extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      action: props.action || 'DROP',
      chain: props.chain || 'INPUT',
      protocol: props.protocol || 'TCP',
      srcIp: props.srcIp || '',
      srcPort: props.srcPort || '',
      dstIp: props.dstIp || '',
      dstPort: props.dstPort || '',
      matchString: props.matchString || '',
    };
  }
  componentDidMount() {
    this.update();
  }
  update = () => {
    if (this.props.onChange) {
      this.props.onChange(this.rule);
    }
  }
  get rule() {
    return new Rule(
      this.state.action,
      this.state.chain,
      this.state.protocol,
      this.state.srcIp,
      Protocols[this.state.protocol].hasPorts ? this.state.srcPort : '',
      this.state.dstIp,
      Protocols[this.state.protocol].hasPorts ? this.state.dstPort : '',
      this.state.matchString,
    );
  }
  render() {
    return (
      <Form className="RuleEditor">
        You want to

        <Form.Control
          as="select"
          size="sm"
          className="RuleEditor-rule-item"
          value={this.state.action}
          onChange={event => this.setState({action: event.target.value}, this.update)}>
          <option value="DROP">drop</option>
          <option value="REJECT">reject</option>
          <option value="ACCEPT">accept</option>
        </Form.Control>

        <br/>
        all

        <Form.Control
          as="select"
          size="sm"
          className="RuleEditor-rule-item"
          value={this.state.chain}
          onChange={event => this.setState({chain: event.target.value}, this.update)}>
          <option value="INPUT">incoming</option>
          <option value="OUTPUT">outgoing</option>
          <option value="FORWARD">forwarding</option>
        </Form.Control>

        <Form.Control
          as="select"
          size="sm"
          className="RuleEditor-rule-item"
          value={this.state.protocol}
          onChange={event => this.setState({protocol: event.target.value}, this.update)}>
          <option value="IP">IP</option>
          <option value="TCP">TCP</option>
          <option value="UDP">UDP</option>
          <option value="ICMP">ICMP</option>
        </Form.Control>

        traffic

        <br/>
        that comes from

        <Form.Control
          type="text"
          size="sm"
          placeholder="IP, Range or leave empty"
          className="RuleEditor-rule-item"
          value={this.state.srcIp}
          onChange={event => this.setState({srcIp: event.target.value.trim()}, this.update)} />
        :
        <Form.Control
          type="text"
          size="sm"
          placeholder="Port or leave empty"
          className="RuleEditor-rule-item"
          disabled={!Protocols[this.state.protocol].hasPorts}
          value={Protocols[this.state.protocol].hasPorts ? this.state.srcPort : ''}
          onChange={event => this.setState({srcPort: event.target.value.trim()}, this.update)}/>

        <br/>
        and goes to

        <Form.Control
          type="text"
          size="sm"
          placeholder="IP, Range or leave empty"
          className="RuleEditor-rule-item"
          value={this.state.dstIp}
          onChange={event => this.setState({dstIp: event.target.value.trim()}, this.update)} />
        :
        <Form.Control
          type="text"
          size="sm"
          placeholder="Port or leave empty"
          className="RuleEditor-rule-item"
          disabled={!Protocols[this.state.protocol].hasPorts}
          value={Protocols[this.state.protocol].hasPorts ? this.state.dstPort : ''}
          onChange={event => this.setState({dstPort: event.target.value.trim()}, this.update)} />

        <br/>
        and contains

        <Form.Control
          type="text"
          size="sm"
          placeholder="String or leave empty"
          className="RuleEditor-rule-item"
          value={this.state.matchString}
          onChange={event => this.setState({matchString: event.target.value}, this.update)} />

        ?
      </Form>
    );
    }
}

export default RuleEditor;
